export const search = {
  searching: "جارٍ البحث عن صاحب السيارة...",
  plateNumber: "رقم اللوحة",
  enterPlateNumber: "أدخل رقم اللوحة",
  scanPlate: "مسح اللوحة",
  searchResults: "نتائج البحث",
  ownerFound: "تم العثور على صاحب السيارة",
  noResults: "لا توجد نتائج",
  noResultsMessage: "لا توجد نتائج، يمكنك المحاولة لاحقاً أو الاشتراك لمزيد من عمليات البحث",
  contactNow: "تواصل الآن",
  whatsapp: "واتساب",
  phone: "الهاتف",
  email: "البريد الإلكتروني",
  retakePhoto: "إعادة التصوير",
  confirmPlate: "تأكيد رقم اللوحة",
  plateDetected: "تم اكتشاف رقم اللوحة",
  processing: "جاري المعالجة...",
  searchAgain: "بحث مرة أخرى"
};